import { getCookie } from "./functions";
/**
 * autocomplete
 * @param {string} inputId
 */
const autocomplete = (inputId) => {
    /*the autocomplete function takes two arguments,
    the text field element and an array of possible autocompleted values:*/
    let currentFocus;
    let arr = [];
    let inp;
    let url;
    let responseName;
    try {
        inp = document.getElementById(inputId);
        url = inp.getAttribute("data-url");
        responseName = inp.getAttribute("data-colTarget");
    } catch (error) {}
    let csrf_token = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
    /*execute a function when someone writes in the text field:*/
    try {
        inp.addEventListener("input", function (e) {
            let data = new FormData();
            let keyWord = e.target.value;
            data.append("key_word", keyWord);
            fetch(url, {
                method: "POST",
                headers: {
                    "X-CSRF-TOKEN": csrf_token,
                },
                body: data,
            })
                .then(function (response) {
                    return response.json();
                })
                .then(function (result) {
                    // console.log('ok')
                    arr = [];
                    // console.log(result)
                    for (
                        let index = 0;
                        index < result.response.length;
                        index++
                    ) {
                        if (responseName == "state") {
                            arr.push(result.response[index].state);
                        } else if (responseName == "city") {
                            arr.push(result.response[index].city);
                        }
                    }

                    // console.log(arr);
                    var a,
                        b,
                        i,
                        val = keyWord;
                    /*close any already open lists of autocompleted values*/
                    closeAllLists();
                    if (!val) {
                        return false;
                    }
                    currentFocus = -1;
                    /*create a DIV element that will contain the items (values):*/
                    a = document.createElement("DIV");
                    a.setAttribute("id", "custom-autocomplete-list");
                    a.setAttribute("class", "autocomplete-items");
                    /*append the DIV element as a child of the autocomplete container:*/
                    inp.parentNode.appendChild(a);
                    /*for each item in the array...*/
                    for (i = 0; i < arr.length; i++) {
                        /*check if the item starts with the same letters as the text field value:*/
                        if (
                            arr[i].substr(0, val.length).toUpperCase() ==
                            val.toUpperCase()
                        ) {
                            /*create a DIV element for each matching element:*/
                            b = document.createElement("DIV");
                            /*make the matching letters bold:*/
                            b.innerHTML =
                                "<strong>" +
                                arr[i].substr(0, val.length) +
                                "</strong>";
                            b.innerHTML += arr[i].substr(val.length);
                            /*insert a input field that will hold the current array item's value:*/
                            b.innerHTML +=
                                "<input type='hidden' value='" + arr[i] + "'>";
                            /*execute a function when someone clicks on the item value (DIV element):*/
                            b.addEventListener("click", function (e) {
                                /*insert the value for the autocomplete text field:*/
                                inp.value =
                                    this.getElementsByTagName("input")[0].value;
                                closeAllLists();
                            });
                            a.appendChild(b);
                            //
                        }
                    }
                });
        });
    } catch (error) {}
    try {
        /*execute a function presses a key on the keyboard:*/
        inp.addEventListener("keyup", function (e) {
            var x = document.getElementById("custom-autocomplete-list");
            if (x) x = x.getElementsByTagName("div");
            if (e.keyCode == 40) {
                /*If the arrow DOWN key is pressed,
            increase the currentFocus variable:*/
                currentFocus++;
                /*and and make the current item more visible:*/
                addActive(x);
            } else if (e.keyCode == 38) {
                //up
                /*If the arrow UP key is pressed,
            decrease the currentFocus variable:*/
                currentFocus--;
                /*and and make the current item more visible:*/
                addActive(x);
            } else if (e.keyCode == 13) {
                /*If the ENTER key is pressed, prevent the form from being submitted,*/
                e.currentTarget.preventDefault();
                if (currentFocus > -1) {
                    /*and simulate a click on the "active" item:*/
                    if (x) x[currentFocus].click();
                }
            }
        });
    } catch (error) {}
    function addActive(x) {
        /*a function to classify an item as "active":*/
        if (!x) return false;
        /*start by removing the "active" class on all items:*/
        removeActive(x);
        if (currentFocus >= x.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = x.length - 1;
        /*add class "autocomplete-active":*/
        x[currentFocus].classList.add("autocomplete-active");
    }

    function removeActive(x) {
        /*a function to remove the "active" class from all autocomplete items:*/
        for (var i = 0; i < x.length; i++) {
            x[i].classList.remove("autocomplete-active");
        }
    }

    function closeAllLists(elmnt) {
        /*close all autocomplete lists in the document,
        except the one passed as an argument:*/
        var x = document.getElementsByClassName("autocomplete-items");
        for (var i = 0; i < x.length; i++) {
            if (elmnt != x[i] && elmnt != inp) {
                x[i].parentNode.removeChild(x[i]);
            }
        }
    }
    /*execute a function when someone clicks in the document:*/
    document.addEventListener("click", function (e) {
        closeAllLists(e.target);
    });
};

export default autocomplete;
